import { CalendarClock, ClipboardList, LayoutDashboard, Settings, Users } from "lucide-react";

export const coachNavItems = [
  { label: "Overview", path: "/coach", icon: LayoutDashboard, end: true },
  { label: "Schedule", path: "/coach/schedule", icon: CalendarClock },
  { label: "Assessments", path: "/coach/assessments", icon: ClipboardList },
  { label: "Players", path: "/coach/players", icon: Users },
  { label: "Settings", path: "/coach/settings", icon: Settings },
];
